"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleProductDetailView = void 0;
var lodash_1 = require("lodash");
var moment_1 = require("moment");
var _1 = require(".");
var handleProductDetailView = function (mutation, state) {
    var product = state.planning.shopItem.item.trip;
    var ports = state.planning.shop.cruiseData.ports;
    var agencyId = (0, lodash_1.get)(state, 'planning.shop.agencyData.number', '');
    var isRecommendationProduct = state.planning.shopItem.isRecommendationProduct;
    var events = [
        {
            event: 'EECproductDetailView',
            ecommerce: {
                currencyCode: 'EUR',
                dimension67: agencyId,
                detail: {
                    actionField: {
                        list: isRecommendationProduct
                            ? 'cpl_cart_recommendations'
                            : 'Cruiseplaner',
                    },
                    products: [
                        {
                            name: product.title,
                            id: product.iCode,
                            price: product.prices[0].price.toString(),
                            brand: (function () {
                                var port = ((0, lodash_1.find)(ports, function (p) { return p.port.code === product.portCode; }) || 'none').port;
                                return port
                                    ? port.name +
                                        ' (' +
                                        port.countryCd +
                                        ')' +
                                        '/' +
                                        (0, moment_1.utc)(product.date).format('DD.MM.YYYY')
                                    : 'none';
                            })(),
                            category: (0, lodash_1.join)((product || {}).mainCategoryCodes, '/'),
                            variant: (0, lodash_1.join)((product || {}).categoryCodes, '/'),
                            dimension31: state.planning.shop.cruiseData.cruiseIds.join('/'),
                            dimension32: 'OBR',
                            dimension37: state.planning.shop.cruiseData.regionNames.join('/'),
                            dimension42: state.planning.shop.cruiseData.shipNames.join('/'),
                            dimension43: state.planning.shop.bookingData.priceModel,
                            dimension44: (0, _1.getCabinType)(state),
                            dimension45: state.planning.shop.cruiseData.daysTillDeparture,
                        },
                    ],
                },
            },
        },
    ];
    return events;
};
exports.handleProductDetailView = handleProductDetailView;
//# sourceMappingURL=product_detail_view.js.map